import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";
import { categorias, produtos } from "@/mocks/products";
import type { Produto } from "@/mocks/products";
import ProductFilters from "./ProductFilters";
import ProductCard from "./ProductCard";
import ProductModal from "./ProductModal";

export default function ProductCatalog() {
  const [ativo, setAtivo] = useState("todos");
  const [selecionado, setSelecionado] = useState<Produto | null>(null);

  const filtrados = useMemo(() => {
    const lista = ativo === "todos" ? produtos : produtos.filter((p) => p.categoria === ativo);
    return [...lista].sort((a, b) => a.ordem - b.ordem);
  }, [ativo]);

  return (
    <section id="portfolio" className="relative bg-background-50 py-16 md:py-20 lg:py-24">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-500/25 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <SectionLabel>Portfólio</SectionLabel>
          <h2 className="mt-5 font-heading text-3xl font-medium leading-[1.15] text-foreground-950 md:text-5xl">
            Nosso portfólio
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            Uma seleção de produtos voltada para diferentes segmentos e necessidades do mercado.
          </p>
        </Reveal>

        <div className="mt-10 md:mt-12">
          <ProductFilters categorias={categorias} ativo={ativo} onChange={setAtivo} />
        </div>

        <div
          data-product-shop
          className="mt-12 grid grid-cols-2 gap-x-5 gap-y-10 md:mt-16 md:grid-cols-3 md:gap-x-6 md:gap-y-14 lg:grid-cols-4"
        >
          {filtrados.map((produto, index) => (
            <Reveal key={produto.id} delay={(index % 4) * 80}>
              <ProductCard produto={produto} onSelect={setSelecionado} />
            </Reveal>
          ))}
        </div>

        <div className="mt-14 flex items-center gap-4">
          <span className="h-px flex-1 bg-background-200" />
          <p className="ocean-label whitespace-nowrap text-[9px] text-foreground-500 md:text-[10px]">
            {filtrados.length} {filtrados.length === 1 ? "produto" : "produtos"}
          </p>
        </div>
      </div>

      <ProductModal produto={selecionado} onClose={() => setSelecionado(null)} />
    </section>
  );
}